import { until } from 'async'
import Keycloak from 'keycloak-js'
import { ref } from 'vue'

const {
    MODE
} = import.meta.env

function startTokenRefresh(keycloak) {
    setInterval(() => {
        keycloak.updateToken(5)
            .then(refreshed => {
                if (MODE !== 'production') {
                    console.log(refreshed ? 'Token was refreshed' : 'Token is still valid')
                }
            })
            .catch(() => {
                console.error('Failed to refresh the token:', error)
                keycloak.logout()
            })
    }, 60000)
}

async function getSubletUsername(app) {
    const { $api, $keycloak } = app.config.globalProperties

    const data = await $api.assignSubletUsername($keycloak.value.token)

    return data?.name
}
const keycloakPlugin = {
    async install(app, options) {
        const keycloak = ref(new Keycloak(options.keycloakConfig))

        delete options.keycloakConfig

        keycloak.value.isLoading = true
        keycloak.value.isLoaded = new Promise(resolve => until(
            callback => { /** console.log('.'); */callback(null, keycloak.value.isAuthenticated !== undefined) },
            async () => await new Promise(resolve => setTimeout(resolve)),
            () => {
                keycloak.value.isLoading = false
                resolve(true)
            }
        ))
        keycloak.value.defaultLogin = keycloak.value.login
        keycloak.value.signin = keycloak.value.login
        keycloak.value.login = options => keycloak.value.defaultLogin({ ...options || {}, redirectUri: `${window.location.origin}/account?signedIn=1` })
        // Expose $keycloak as a computed property
        app.config.globalProperties.$keycloak = keycloak

        try {
            keycloak.value.onAuthSuccess = () => {
                startTokenRefresh(keycloak.value)
                if (!keycloak.value.tokenParsed.subletUsername) {
                    getSubletUsername(app)
                }
            }
            // Initialize Keycloak and set it to keycloakRef
            keycloak.value.isAuthenticated = await keycloak.value.init(options)
        } catch (error) {
            console.error('Failed to initialize adapter:', error)
        }
    }
}

export default keycloakPlugin
